import { render, staticRenderFns } from "./student-notice.vue?vue&type=template&id=400dc3b1&scoped=true&"
import script from "./student-notice.vue?vue&type=script&lang=js&"
export * from "./student-notice.vue?vue&type=script&lang=js&"
import style0 from "./student-notice.vue?vue&type=style&index=0&id=400dc3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400dc3b1",
  null
  
)

export default component.exports